import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgErrorreact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "replace",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 17.744L17.744 20L12 14.256L6.256 20L4 17.744L9.744 12L4 6.256L6.256 4L12 9.744L17.744 4L20 6.256L14.256 12L20 17.744Z" })
});
export default SvgErrorreact;
